export default "__VITE_ASSET__1vW6zF9r__"